import type { HostModeEntryPhase } from '../../../../coordinators/rewards/HostModeEntryController';
import type { CategorizedGates } from '../../../../coordinators/rewards/categorizeGates';
import { serviceContainer } from '../../../../services/ServiceContainer';
import { AppsRunningModal } from './AppsRunningModal';
import { RestartToFinishSetupModal } from './RestartToFinishSetupModal';
import { PleaseWaitModal } from './PleaseWaitModal';
import { ContactSupportModal } from './ContactSupportModal';
import { SeveralIssuesModal } from './SeveralIssuesModal';
import { RestartConfirm } from '../RestartConfirm';

interface HostModeOverlayProps {
  phase: HostModeEntryPhase;
  categorized: CategorizedGates | null;
  onDismiss: () => void;
  onConfirmRestart: () => void;
  restartNow: () => void;
}

export const HostModeOverlay = ({
  phase,
  categorized,
  onDismiss,
  onConfirmRestart,
  restartNow,
}: HostModeOverlayProps) => {
  const handleDismiss = (action: string) => {
    serviceContainer.analyticsManager.sendHostModeModalDismissedEvent({ phase, action });
    onDismiss();
  };

  switch (phase) {
    case 'apps-running':
      return <AppsRunningModal apps={categorized?.appsHolding ?? []} onDismiss={() => handleDismiss('close')} />;
    case 'restart-setup':
      return <RestartToFinishSetupModal onConfirmRestart={onConfirmRestart} onDismiss={() => handleDismiss('cancel')} />;
    case 'please-wait':
      return <PleaseWaitModal onDismiss={() => handleDismiss('close')} />;
    case 'contact-support':
      return <ContactSupportModal onDismiss={() => handleDismiss('acknowledge')} />;
    case 'several-issues':
      return categorized ? <SeveralIssuesModal categorized={categorized} onDismiss={() => handleDismiss('close')} /> : null;
    case 'restart-confirm':
      return <RestartConfirm onRestartNow={restartNow} onNotNow={() => handleDismiss('cancel')} />;
    default:
      return null;
  }
};
